import {
  ContentEditableInput,
  TextPageHeader,
  TooltipBubble,
} from '@carboncopyco/ui';

export interface InfoPageEditableTitleProps {
  title?: string;
  onTitleChange: (newTitle: string) => void;
  disabled: boolean;
}
export const InfoPageEditableTitle = ({
  title,
  onTitleChange,
  disabled,
}: InfoPageEditableTitleProps) => {
  return (
    <ContentEditableInput
      disabled={disabled}
      onChange={onTitleChange}
      bordered
      inputSize="xxl"
    >
      <TooltipBubble
        placement="top-start"
        title={title}
      >
        <TextPageHeader
          label={title}
          ellipsis
          color="text-ds-natural-700"
        />
      </TooltipBubble>
    </ContentEditableInput>
  );
};
